import { defineStore } from 'pinia'
import { ref } from 'vue'

import { detectAdBlock, type AdBlockStatus } from '@/modules/adv/ad-block-detector'
import type { LoggerEvent } from '@/types/logger.types'

export const useAdBlockStore = defineStore('adBlock', () => {
    const adBlockStatus = ref<AdBlockStatus>('unknown')

    async function detectAdBlockStatus(logEvent: (event: LoggerEvent) => void) {
        adBlockStatus.value = await detectAdBlock(logEvent)
    }

    return {
        adBlockStatus,
        detectAdBlockStatus,
    }
})
